module.exports = __webpack_public_path__ + "img/lunbo121.e3f92b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo121.png
// module id = WtFF
// module chunks = 0